<div class="login-wrapper loginSpinnerDiv">
    <div class="login-left"></div>
        <div class="login-right">
            <div class="login-container">
                <div class="login-box" *ngIf="currentState != 'verified'">
                    <div class="login-logo text-center">
                        <img src="../../../assets/images/logo.png">
                    </div>
                    <p class="text-center" *ngIf="currentState == 'wait'">Please wait...</p>
                    <h2 class="text-center" *ngIf="currentState == 'notVerified'">Unable to reset password</h2>
                    <p class="text-center" *ngIf="currentState == 'notVerified'">The reset link is invalid or expired. Try requesting a new one.</p>                    
                </div>
                <div class="login-box" *ngIf="currentState == 'verified'">
                    <div class="login-logo text-center">
                        <img src="../../../assets/images/logo.png">
                    </div>
                    <h2 class="text-center">Reset Your Password?</h2>
                    <p class="text-center">Enter new password and confirm password</p>
                    <p-messages [showTransitionOptions]="'300ms'" [hideTransitionOptions]="'200ms'" [(value)]="msgs"></p-messages>
                    <div class="message message-error" [hidden]="!showToggle">
                        <div class="message-wrapper">
                            <span class="message-icon pi pi-times-circle"></span>
                            <p>{{ errorMessage }}</p>
                            <button class="p-message-close" type="button" (click)=closeErrorDiv()>
                                <i class="p-message-close-icon pi pi-times"></i>
                            </button>
                        </div>
                    </div>
                    <form class="mt-4 mb-4" name="updatePasswordForm" (ngSubmit)="f.valid && updatePassword(model)" #f="ngForm" novalidate>                     
                        <div class="p-fluid">
                            <div class="p-field">
                                <label for="email">Email address</label>
                                <input id="email" type="text" name="email" pattern="(^[a-zA-Z0-9_.+-]+@[a-zA-Z0-9-]+\.[a-zA-Z0-9-.]+$)" [(ngModel)]="model.email" #email="ngModel" pInputText [disabled]="true">
                            </div>                            
                            <div class="p-field">
                                <label for="newPassword">New Password</label>
                                <input autocomplete="new-password" id="newPassword" pPassword type="password" name="newPassword" pPassword [(ngModel)]="model.newPassword" #newPassword="ngModel" pInputText [ngClass]="{ 'is-invalid': f.submitted && newPassword.invalid }" (ngModelChange)="passwordChanged()" required>
                                <div *ngIf="f.submitted && newPassword.invalid" class="invalid-feedback">
                                    <span *ngIf="newPassword.errors.required" class="error-message">
                                        <span class="p-message-icon pi pi-times"></span> New Password is required
                                    </span>
                                </div>
                            </div>
                            <div class="p-field">
                                <label for="confirmPassword">Confirm Password</label>
                                <input id="confirmPassword" type="password" name="confirmPassword" [(ngModel)]="model.confirmPassword" #confirmPassword="ngModel" pInputText [ngClass]="{ 'is-invalid': f.submitted && confirmPassword.invalid }" (ngModelChange)="passwordChanged()" required>
                                <div *ngIf="f.submitted && confirmPassword.invalid" class="invalid-feedback">
                                    <span *ngIf="confirmPassword.errors.required" class="error-message">
                                        <span class="p-message-icon pi pi-times"></span> Confirm Password is required
                                    </span>
                                </div>
                                <div *ngIf="f.submitted && !validConfirmPassword" class="mt-quarter">
                                    <div class="error-message">
                                        <span class="p-message-icon pi pi-times"></span> Password and Confirm Password must be same.
                                    </div>
                                </div>                                
                            </div>
                        </div>
                        <div class="loginSpinner">
                            <p-progressSpinner [style]="{width: '50px', height: '50px'}" strokeWidth="5" [hidden]="!showSpinner"></p-progressSpinner>
                        </div>
                        <button pButton label="Reset" class="btn-block mt-2" [disabled]="showSpinner || f.invalid || !validConfirmPassword"></button>
                    </form>
                </div>
            </div>
        </div>
    </div>